import { Component, OnInit, Input, Inject,  OnDestroy } from '@angular/core';
//import { MenuService } from '../../_service/menu/menu.service';
import { Dropdown } from '../dn-user-menu/dropdown/dropdown';
import { RechargeBoxService } from '../../_service/recharge-box/recharge-box.service';
// import { Store } from 'redux';
// import { AppStore } from '../../app.store';
// import { UsersState } from '../../_model/user/user.reducer';
import { DropdownRechargeComponent } from '../../components/dn-user-menu/dropdown-recharge/dropdown-recharge.component';
//import { DOCUMENT } from '@angular/common';
import { Utility } from '../../_service/utility';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { StorageService } from 'app/storageprovider';
import { DnDialogService } from 'app/_modules/dn-dialog/dn-dialog.service';
import { fromEvent, Subscription, Unsubscribable } from 'rxjs';
import { UserService } from '../../_service/user/user.service';
import { ConfigService } from 'app/_service/config/config.service';
import { ScriptService } from '../../_service/script.service';
import { animateDebounce } from '../../_service/animateDebounce';
import { MenuService } from 'app/_service/menu/menu.service';
import { RegionService } from '../../_service/region/region.service';
import { AppStore } from '../../app.store';
import { Store } from 'redux';
import { ConfigState } from '../../_model/config/config.reducer';
import * as configActions from '../../_model/config/config.actions';

//const SVGA = require('svgaplayerweb');
declare var SVGA;
@Component({
  selector: 'div.navbar',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscript();

  }


  subscription: Array<Unsubscribable> = [];
  //isApp = environment.app;
  @Input()
  alwaysFixed = true;

  //isAdult = environment.cinema === 2;
  //allVip = false;

  // screenSize;
  // screenType = ScreenSize;

  user;
  public fixed = this.alwaysFixed;
  ads: Dropdown[];

  rechargeMenuItem = {
    title: '开通VIP',
    authentication: false,
    link: null,
    icon: 'iconVIP',
    iconSize: '',
    selected: false,
    expanded: false,
    order: 100,
    seprator: false,
    externalLink: false,
    rect: {
      left: 0,
      top: 0,
      width: 84,
      height: 0
    },
    dropdown: new Dropdown(DropdownRechargeComponent, {
      width: 240,
    }),
    notification: null
  };

  oldVersionMenuItem = {
    title: '旧版',
    authentication: false,
    link: null,
    icon: 'icon-recharge',
    iconSize: '',
    selected: false,
    expanded: false,
    order: 100,
    seprator: false,
    externalLink: false,
    rect: {
      left: 0,
      top: 0,
      width: 54,
      height: 0
    },
    dropdown: null,
    notification: null
  };

  isDark = false;
  dynamicBg = true;
  ifPlayPage = false;
  darkBg = false;
  lightMode_DarkLogo = false;
  noBgTransition = false;
  subscriptions: Subscription[] = [];
  dynamicBgArray = [
    "user",
    "space",
    "list",
    "short-videos",
    "search",
    "vods",
    "vod",
    "studio",
    "discovery",
    "vip-center",
    "bargain-event",
  ]
  showDiscovery = false;
  ifInvite = false;
  topNavButton = [];
  ifLottery = false;
  randomPrize; // 随机奖品
  changeFadeIn = false;
  constructor(
    //@Inject(DOCUMENT) private document: Document,
    //  private menuService: MenuService,
    private _rechargeBoxService: RechargeBoxService,
    // private _windowService: WindowService,
    // @Inject(AppStore) private store: Store<UsersState>,
    private _router: Router,
    private _storage: StorageService,
    private _dnDialogService: DnDialogService,
    private _userService: UserService,
    private _utility: Utility,
    private configService: ConfigService,
    private _script: ScriptService,
    private _menuService: MenuService,
    private _regionService: RegionService,
    @Inject(AppStore) private store: Store<ConfigState>,
  ) {


  }


  //stickLeft = "";
  // private unsb = null;
  addBg = false;

  timer = null;
  disableHover = false;




  onWindowScroll() {
    if (this.ifPlayPage && !this.isDark) { // 亮版，播放页，TopNav动态背景，采用深色版背景
      if (this._utility.getWindow().scrollY > 0) {
        this.darkBg = true;
      } else {
        this.darkBg = false;
      }
    }
    if (!this.dynamicBg && !this.isDark) { // 亮版且特定页，TopNav固定背景
      this.addBg = true;
    } else {
      if (this._utility.getWindow().scrollY > 0) {
        this.addBg = true;
        if (!this.ifPlayPage && !this.isDark) {
          this.lightMode_DarkLogo = false; // 亮版，非播放页，滚动后，采用浅色logo
        }
      }
      else {
        this.addBg = false;
        if (!this.ifPlayPage && !this.isDark) {
          this.lightMode_DarkLogo = true; // 亮版，非播放页，未滚动或回顶部，采用深色logo
        }
      }
      //this.resetVisibility();
    }
    // 可用的数据： window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop
    if (this.alwaysFixed) {
      return;
    }

    if (this._utility.getWindow().screenY > 540) {
      if (!this.fixed) {
        this.fixed = true;
      }
    } else {
      if (this.fixed) {
        this.fixed = false;
      }
    }
  }
  readConfigState() {
    const state = this.store.getState()['config'];
    if (!!state.config.logoUrl) {
      this.logoUrl = state.config.logoUrl;
      this.logoDark = state.config.logoUrl.replace(".png", ".dark.png");
    }
    if (!!state.config && !!state.config.region)
      this._storage.SetConfig({
        region: state.config.region
      })

  }
  subscript = null;

  ngOnInit() {

    // this.isDark = Utility.isDarkMode();
    const region = this._storage.GetConfig()["region"];// this._cookieService.get('config');
    this.isDark = !!parseInt(this._storage.GetConfig()["isDark"] || "1");
    this.subscript = this.store.subscribe(() => this.readConfigState());
    this.subscriptions.push(
      this._regionService.switchRegion(region).subscribe(res => {
        // console.log(res);
        this.store.dispatch({
          type: configActions.UPDATEREGION,
          config: {
            region: res.regionCode,
            logoUrl: res.largeLogo//.replace("rv19","rv20"),
          }
        });
      }),
      this._router.events.subscribe(e => {
        if (e instanceof NavigationEnd) {
          // console.log(this._router.url);
          // this.dynamicBg = this._router.url === '/' ? true : false; // 仅主页TopNav随滚动动态增加背景
          const mainRoute = this._router.url.split('/')[1].split('?')[0];
          this.dynamicBg = this.dynamicBgArray.indexOf(mainRoute) > -1 ? false : true; // 是否动态背景，特定页TopNav固定背景，其余页TopNav随滚动动态增加背景
          if (!this.dynamicBg && !this.isDark) { // 亮版且特定页，TopNav固定背景
            this.addBg = true;
            this.lightMode_DarkLogo = false; // TopNav固定背景，加载时，默认采用浅色版logo
          } else {
            const ifNeedKeepBg = this._router.url.split('?')[0];
            if (ifNeedKeepBg === '/user/messages/chat' || ifNeedKeepBg === '/user/my-upload' || ifNeedKeepBg === '/space') {
              return; // 聊天页面时切换聊天对象，我的投稿，个人主页 不调整TopNav背景
            }
            this.addBg = this._utility.getWindow().scrollY > 0;
            this.lightMode_DarkLogo = true; // TopNav动态背景，加载时，默认采用深色版logo
          }
          this.ifPlayPage = mainRoute === 'watch'
            || mainRoute === 'play' ? true : false; // 是否播放页
          if (!this.ifPlayPage && !this.isDark) { // 亮版，非播放页，TopNav不采用深色版背景
            this.darkBg = false;
          }
          setTimeout(() => {
            this.noBgTransition = false; // 跳转结束，重新启用TopNav的动画效果
          }, 200);
          if (mainRoute === 'discovery') {
            this.showDiscovery = false;
          } else {
            this.showDiscovery = true;
          }
        };
        if (e instanceof NavigationStart) {
          this.noBgTransition = true; // 跳转开始，不启用TopNav的动画效果
        }
      }),

      this.configService.config$.subscribe(p => {
        if (!!p.inviteSwitch) {
          this.ifInvite = p.inviteSwitch;
          setTimeout(() => {
            this.inviteSVGA();
          }, 0);
        }
        if (!!p.choujiangSwitch) {
          this.ifLottery = p.choujiangSwitch;
          if (this.ifLottery) {
            this.randomPrize = this._utility.getRandomPrize();
            setInterval(() => {
              this.fadeInPrize();
            }, 3000); // 3秒一切
          }
        }
      }),

      fromEvent(window, "scroll", { passive: true }).subscribe(animateDebounce(this.onWindowScroll.bind(this)).bind(this)),

      this._menuService.getTopNavButton().subscribe(res => {
        this.topNavButton = res.slice(0, 3);
      }),

    );

    this.user = this._userService.user;
    this.subscriptions.push(

      this._userService.userState$.subscribe(user => {
        this.user = user;
        this.readState();
      }),
      // this._windowService.size$.subscribe((value: any) => {
      //   this.screenSize = value;
      //   this.detectSticker();
      // }),


      //this.detectSticker();

      this._utility.GetOrCreateSubscript("theme.change").subscribe((theme) => {
        // console.log(theme)
        this.isDark = theme == "dark";

        // 切换颜色后
        if (this._utility.getWindow().scrollY > 0) {
          if (this.ifPlayPage) { // 亮版，播放页，滚动后，采用深色版背景
            this.darkBg = !this.isDark;
          }
          if (!this.ifPlayPage && !this.isDark) { // 亮版，非播放页，滚动后，采用浅色版背景，采用浅色logo
            this.darkBg = false;
            this.lightMode_DarkLogo = false;
          }
        } else {
          if (this.ifPlayPage && !this.isDark) { // 亮版，播放页，未滚动或回顶部，采用浅色版背景
            this.darkBg = false;
          }
          if (!this.ifPlayPage && !this.isDark) { // 亮版，非播放页，未滚动或回顶部，采用深色logo
            this.lightMode_DarkLogo = true;
          }
          if (!this.dynamicBg && !this.isDark) { // 亮版且特定页，TopNav固定背景，采用浅色logo
            this.addBg = true;
            this.lightMode_DarkLogo = false;
          }
        }

        //  this.resetVisibility();
      })
    )
    //this.resetVisibility();
  }
  siteName = this._utility.getSiteConfig.title;
  logoUrl: string = this._utility.GetHost(`https://static.{Host}/images/${this._utility.getSiteConfig.siteKey}gl.png?v=8`);
  logoDark: string = this._utility.GetHost(`https://static.{Host}/images/${this._utility.getSiteConfig.siteKey}gl.dark.png?v=8`);
  //darkVisible = false;
  showDiscount = false;
  // resetVisibility() {
  //   if (this.isDark || this.lightMode_DarkLogo) {
  //     this.darkVisible = true;
  //   }
  //   else {
  //     this.darkVisible = false;
  //   }
  // }
  //

  //uploadWidth = "108px";
  detectSticker() {
    // if (this.isApp) {
    //   //console.log(this.screenSize)
    //   if (this.screenSize != 2) {
    //     this.stickLeft = "-1.3em";
    //   }
    //   else {
    //     this.stickLeft = "-3.19em";
    //   }
    //   //console.log(this.screenSize)
    //   //this.stickLeft = //"-3.19em";
    // }
    // if (this.screenSize == 3) {
    //   this.uploadWidth = "200px";
    // }
    // else {
    //   this.uploadWidth = "108px";
    // }
    //console.log(this.screenSize);
  }
  readState() {
    // const state: UsersState = this.store.getState()['users'] as UsersState;
    // const configState = this.store.getState()['config'];
    // if (configState.config.allVip) {
    //   this.allVip = true;
    // }
    // this.user = new User(true);
    // Object.assign(this.user, state.currentUser);
    this.rechargeMenuItem.title = this.user.rechargeWords;
  }

  showRechargeBox() {
    this._rechargeBoxService.changeDisplayStatus(true);
    // this._router.navigate(['/vip-center/recharge'], { queryParams: {forOther: '0'} });
  }

  colorChange() {
    var isDark = !!parseInt(this._storage.GetConfig()["isDark"] || "1");
    this._storage.SetConfig({ isDark: !isDark ? 1 : 0 });
    if (isDark) {
      document.body.classList.add("light");
    }
    else {
      document.body.classList.remove("light");
    }
    this._utility.Notify("theme.change", isDark ? "light" : "dark");
  }

  askLeave() {
    this._dnDialogService.open('ask-leave-dialog');
  }

  inviteSVGA() {
    this._script.load("svgaplayer").then(() => {
      //console.log(SVGA)
      const inviteSvgaUrl = this._utility.getAbsUrl('assets/images/user-center/invite_vip.svga');
      const player = new SVGA.Player('#inviteSvgaCanvas');
      const parser = new SVGA.Parser('#inviteSvgaCanvas'); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。

      parser.load(inviteSvgaUrl, videoItem => {
        // console.log('svga播放成功');
        player.loops = 0;  // 设置循环播放次数 0表示无限循环
        player.setVideoItem(videoItem);
        player.setContentMode('AspectFit'); // "ScaleToFill" | "AspectFill" | "AspectFit"
        player.startAnimation();
        player.onFinished(() => {
        });
      }, error => {
        console.log('svga播放失败');
      });

      /*
      ** AspectFill：在保持长宽比的前提下，缩放图片，使图片充满容器。
      ** AspectFit：在保持长宽比的前提下，缩放图片，使得图片在容器内完整显示出来。
      ** ScaleToFill: 缩放图片,使图片充满容器。图片未必保持长宽比例协调，有可能会拉伸至变形。
      */
    })

  }

  navToInvite() {
    this._router.navigate(['/user/invite']);
  }

  navToMyUpload() {
    this._router.navigate(['/user/my-upload']);
  }

  enterLottery() {
    this._router.navigate(['/activity/lottery']);
  }


  fadeInPrize() {
    const buttonElement = document.getElementById('l-button');
    const nameElement = document.getElementById('l-name');
    if (!this.changeFadeIn) {
      buttonElement.classList.remove('fade-in');
      nameElement.classList.add('fade-in');
      this.changeFadeIn = true;
    } else {
      buttonElement.classList.add('fade-in');
      nameElement.classList.remove('fade-in');
      this.changeFadeIn = false;
    }
  }
}
